export const NEWS_TYPE = {
  NEWS: 2,
  EVENTS: 1,
  VIDEOS: 4,
  NEWSRELEASE: 3,
};

export const VideoCategory = {
  WTR: 1,
  THYROIDTREATMENT: 2,
  THYROIDDIAGNOSIS: 3,
  BREASTTREATMENT: 4,
  BREASTDIAGNOSIS: 5,
};


